import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, Skeleton, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import ChildCard from '../../../../card/ChildCard'

const CardInfo = ({ isLoading }) => {
  const { curriculumId } = useParams();
  const totalStudents = useSelector((state) => state?.class ? state?.class[curriculumId]?.students || [] : [])
  const totalList = useSelector((state) => state?.class ? state?.class[curriculumId]?.totalList || 0 : 0)
  const permissionsList = useSelector((state) => state?.session?.permissions?.class?.list || [])

  return (
    <div className='flex gap-2'>
      <ChildCard />
      <Card className='flex items-center min-w-150px'>
        <div className='bg-primary p-2'>
          <FontAwesomeIcon
            icon={['fas', 'books']}
            size='2x'
            className='text-primary-foreground'
          />
        </div>
        <div className='px-2 py-1'>
          <Typography variant='inherit' color='primary' className='text-xl font-bold'>{isLoading ? <Skeleton /> : totalList}</Typography>
          <p className='text-muted-foreground opacity-50 text-xs uppercase'>Classes</p>
        </div>
      </Card>
      { (permissionsList.includes('all') || permissionsList?.includes('by-teacher')) && 
        <Card className='flex items-center min-w-180px'>
          <div className='bg-primary p-2'>
            <FontAwesomeIcon
              icon={['fas', 'users']}
              size='2x'
              className='text-primary-foreground'
            />
          </div>
          <div className='px-4 py-1'>
            <Typography variant='inherit' color='primary' className='text-xl font-bold'>{isLoading ? <Skeleton /> : totalStudents.length}</Typography>
            <p className='text-muted-foreground opacity-50 text-xs uppercase'># of students</p>
          </div>
        </Card>
      }
    </div>
  )
}

export default CardInfo